var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "120.000000pt",
    height: "42.000000pt",
    viewBox: "0 0 120.000000 42.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,42.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130 345 c0 -3 -1 -67 -1 -142 l0 -138 135 -3 136 -3 0 146 0 145 -135 0 c-74 0 -135 -2 -135 -5z m157 -31 c7 -20 -17 -37 -34 -23 -15 13 -6 39 13 39 8 0 17 -7 21 -16z m10 -74 c35 -44 37 -55 8 -74 -32 -21 -56 -10 -27 13 20 15 20 17 3 38 l-18 21 -43 -34 c-44 -35 -52 -39 -63 -28 -7 7 93 93 108 93 6 0 20 -13 32 -29z m-33 -39 c3 -5 -1 -14 -9 -21 -12 -10 -12 -15 1 -36 l16 -24 46 40 c42 35 62 42 62 21 0 -8 -102 -91 -112 -91 -2 0 -19 18 -37 40 l-32 41 23 19 c26 22 34 24 42 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 285 c0 -30 5 -55 10 -55 6 0 10 9 10 21 0 21 0 21 20 -2 21 -26 26 -20 10 11 -7 13 -7 21 0 25 16 10 12 42 -6 49 -38 14 -44 7 -44 -49z m40 25 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 285 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55 -5 0 -10 -25 -10 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596 324 c-31 -30 -10 -94 30 -94 34 0 54 20 54 55 0 50 -50 73 -84 39z m63 -23 c13 -24 -8 -55 -35 -49 -20 3 -30 29 -20 54 8 20 43 17 55 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 333 c-11 -10 -8 -91 3 -98 6 -4 10 7 10 27 l1 33 27 -33 c15 -18 31 -30 35 -26 11 11 8 92 -3 99 -6 4 -10 -7 -10 -24 0 -34 -15 -42 -25 -12 -7 23 -29 43 -38 34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810 284 c0 -34 4 -53 10 -49 6 3 10 28 10 56 0 27 -4 49 -10 49 -5 0 -10 -25 -10 -56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868 328 c-17 -13 -21 -28 -19 -60 1 -23 37 -41 67 -34 34 9 30 27 -5 20 -22 -5 -32 -2 -40 14 -16 29 8 57 42 48 29 -7 38 8 11 18 -24 9 -38 7 -56 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 285 c0 -30 5 -55 10 -55 6 0 10 10 10 23 l1 22 20 -24 c25 -31 37 -20 15 15 -17 24 -17 27 0 45 23 25 10 37 -16 14 -18 -16 -20 -16 -20 -2 0 10 -4 17 -10 17 -5 0 -10 -25 -10 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463 185 c-17 -13 -17 -14 5 -37 25 -27 28 -40 9 -36 -7 2 -14 -1 -15 -7 -1 -5 8 -11 21 -13 35 -4 42 24 13 53 -25 25 -25 38 0 28 8 -3 14 -1 14 5 0 17 -27 21 -47 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873 189 c-24 -9 -37 -40 -28 -68 13 -42 90 -39 101 3 12 47 -27 82 -73 65z m55 -52 c-2 -17 -10 -22 -33 -22 -35 0 -47 31 -20 51 25 18 57 0 53 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983 193 c-20 -7 -15 -34 10 -61 l22 -24 -22 4 c-12 1 -22 -1 -23 -7 0 -5 11 -11 25 -13 35 -5 43 23 16 52 -25 26 -27 38 -6 30 8 -4 15 -2 15 4 0 12 -21 21 -37 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 180 c0 -5 5 -10 11 -10 6 0 9 -15 7 -37 -2 -24 2 -38 11 -41 10 -3 12 5 9 37 -2 22 0 41 4 41 5 0 8 5 8 10 0 6 -11 10 -25 10 -14 0 -25 -4 -25 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602 143 c3 -46 4 -48 33 -48 29 0 30 2 33 48 2 28 -1 47 -7 47 -6 0 -11 -18 -11 -40 0 -29 -4 -40 -15 -40 -11 0 -15 11 -15 40 0 22 -5 40 -11 40 -6 0 -9 -19 -7 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700 140 c0 -49 1 -50 30 -50 39 0 59 37 42 75 -9 19 -19 25 -42 25 -29 0 -30 -1 -30 -50z m55 0 c0 -16 -6 -26 -17 -28 -14 -3 -18 3 -18 28 0 25 4 31 18 28 11 -2 17 -12 17 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 140 c0 -27 5 -50 10 -50 6 0 10 23 10 50 0 28 -4 50 -10 50 -5 0 -10 -22 -10 -50z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.e2564531510c304e18c25b5dc839dc82.svg";
export { ForwardRef as ReactComponent };